import React from "react";
import {
    Container,
    Grid,
    Typography,
    Link,
    Divider,
    Box,
} from "@mui/material";
import SocialMedia from "../Dashboard/SocialMedia/SocialMedia";

const Footer = () => {
    return (
        <Box
            sx={{
                backgroundImage: "url('/images/footerbg2.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                py: 6,
            }}
        >
            <Container maxWidth="xl">
                <Grid container spacing={4} justifyContent="space-between" sx={{ px: 5 }}>
                    {/* Solutions */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="h5" gutterBottom>
                            Solutions
                        </Typography>
                        <Box>
                            {[
                                { text: "Big Data & Advanced Analytics", link: "/big-data-and-advanced-analytics" },
                                { text: "Business Intelligence Solutions", link: "/business-intelligence-solutions" },
                                { text: "Data Management", link: "/data-management" },
                                { text: "Enterprise Data Warehouse", link: "/enterprise-data-warehouse" },
                                { text: "Application Middleware Management", link: "/application-middleware-management" },
                            ].map((item) => (
                                <Link
                                    key={item.text}
                                    href={item.link}
                                    color="inherit"
                                    underline="hover"
                                    display="block"
                                    sx={{
                                        my: 0.5,
                                        fontSize: { xs: "0.9rem", sm: "1rem" },
                                    }}
                                >
                                    {item.text}
                                </Link>
                            ))}
                        </Box>
                    </Grid>

                    {/* Services */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="h5" gutterBottom>
                            Services
                        </Typography>
                        <Box>
                            {[
                                { text: "Enterprise Mobility Service", link: "/enterprise-mobility-service/business-process" },
                                { text: "Mobile Apps Development", link: "/mobile-apps-development/android-app-development" },
                                { text: "Business Intelligence Services", link: "/business-intelligence-service" },
                                { text: "Web Application Development", link: "/web-application-development/CRM-application" },
                                { text: "Testing and QA Services", link: "/testing-QA-services/automated-testing" },
                            ].map((item) => (
                                <Link
                                    key={item.text}
                                    href={item.link}
                                    color="inherit"
                                    underline="hover"
                                    display="block"
                                    sx={{
                                        my: 0.5,
                                        fontSize: { xs: "0.9rem", sm: "1rem" },
                                    }}
                                >
                                    {item.text}
                                </Link>
                            ))}
                        </Box>
                    </Grid>

                    {/* Industries */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="h5" gutterBottom>
                            Industries
                        </Typography>
                        <Box>
                            {[
                                { text: "Telecommunications", link: "/telecommunications" },
                                { text: "Retail", link: "/retail" },
                                { text: "Financial Services", link: "/financial-services" },
                                { text: "Manufacturing", link: "/manufacturing" },
                                { text: "Utilities", link: "/utilities" },
                                { text: "Government", link: "/government" },
                            ].map((item) => (
                                <Link
                                    key={item.text}
                                    href={item.link}
                                    color="inherit"
                                    underline="hover"
                                    display="block"
                                    sx={{
                                        my: 0.5,
                                        fontSize: { xs: "0.9rem", sm: "1rem" },
                                    }}
                                >
                                    {item.text}
                                </Link>
                            ))}
                        </Box>
                    </Grid>

                    {/* Company */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="h5" gutterBottom>
                            Company
                        </Typography>
                        <Box>
                            {[
                                { text: "About Us", link: "/aboutus" },
                                { text: "Vision & Mission", link: "/vision-mission" },
                                { text: "Core Value", link: "/core-value" },
                                { text: "Social Responsibility", link: "/social-responsibility" },
                                { text: "Location", link: "/location" },
                                { text: "Team", link: "/teams" },
                                { text: "Contact Us", link: "/enquiry" },
                            ].map((item) => (
                                <Link
                                    key={item.text}
                                    href={item.link}
                                    color="inherit"
                                    underline="hover"
                                    display="block"
                                    sx={{
                                        my: 0.5,
                                        fontSize: { xs: "0.9rem", sm: "1rem" },
                                    }}
                                >
                                    {item.text}
                                </Link>
                            ))}
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ bgcolor: "rgba(255,255,255,0.3)", width: "75%", margin: "20px auto" }} />

                <SocialMedia />

                <Divider sx={{ my: 4, bgcolor: "rgba(255,255,255,0.3)", mt: 2 }} />

                {/* Bottom Section */}
                <Box
                    display="flex"
                    flexDirection={{ xs: "column", sm: "row" }}
                    justifyContent="space-between"
                    alignItems="center"
                    textAlign={{ xs: "center", sm: "left" }}
                >
                    <Box>
                        <Link
                            href="/terms-of-use"
                            color="inherit"
                            underline="hover"
                            sx={{ mr: { sm: 2 }, display: "inline-block", mb: { xs: 1, sm: 0 } }}
                        >
                            Terms of Use
                        </Link>
                        <Link
                            href="/privacy-policy"
                            color="inherit"
                            underline="hover"
                            sx={{ display: "inline-block" }}
                        >
                            Privacy Policy
                        </Link>
                    </Box>
                    <Typography
                        variant="body2"
                        sx={{
                            mt: { xs: 2, sm: 0 },
                            fontSize: { xs: "0.8rem", sm: "0.9rem" },
                        }}
                    >
                        © 2014 - VENSYX Data Solutions
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
